import { TagKeysAndValues } from "../../../usecases/HomeConfig/tagKeys";

export const KEY_OPTIONS = Object.keys(TagKeysAndValues).map((key) => {
  return { label: key, value: key };
});

export const MAX_UPLOAD_BYTES = 5 * 1024 * 1024;
